export const buildOnboardingLogTitle = (step: string, code: string): string => `Onboarding - ${step}. SessionKey: ${code}.`;

export const buildSignalREventLogTitle = (hub: string, event: string): string => `SignalR - Hub: ${hub}, Event: ${event}`;

export const buildSignalRConnectionLogTitle = (hub: string, event: string): string => `SignalR - Hub: ${hub}, Connection event: ${event}`;

export const buildBackendCallSuccessLogTitle = (traceId: string, traceparent: string): string =>
  `Backend call success. ID: ${traceId}. Traceparent: ${traceparent}`;

export const buildBackendCallErrorLogTitle = (traceId: string, traceparent: string): string =>
  `Backend call error. ID: ${traceId}. Traceparent: ${traceparent}`;

export const buildNCFileLoadErrorLogTitle = (ncFileName: string): string => `Error load NC File. NC file name: ${ncFileName}`;

export const buildErrorBoundaryLogTitle = (screenName: string): string => `ErrorBoundary - Render crash on screen: ${screenName}`;

export const buildWallboardLevelChangeLogTitle = (level: string): string => `User change wallboard level to: ${level}`;
